<template>
<div class="q-px-xl q-pb-xl q-mx-auto login-form-wrapper" style="min-width: 350px">
  <h5 class="text-center text-uppercase text-blue-grey-8">Личный кабинет</h5>
  <p class="text-blue-grey-8 text-caption">Используйте логин и пароль из памятки </p>
  <q-form
    @submit.prevent="onSubmit"
    @reset="onReset"
    class="q-gutter-md"
  >
    <q-input
      dense
      filled
      v-model="data.login"
      label="Логин"
      lazy-rules
      :rules="[ val => val && val.length > 0 || 'Обязательное поле']"
    />

    <q-input
      dense
      filled
      :type="isPwd ? 'password' : 'text'"
      v-model="data.password"
      label="Пароль"
      lazy-rules
      class='q-mt-xs'
      :rules="[
        val => val !== null && val !== '' || 'Обязательное поле',
      ]"
    >
    <template v-slot:append>
        <q-icon
          :name="isPwd ? 'visibility_off' : 'visibility'"
          class="cursor-pointer"
          @click="isPwd = !isPwd"
        />
      </template>
    </q-input>

    <div class="flex q-mt-none">
      <q-btn
        size="md"
        push
        class="text-weight-bold full-width"
        color="accent"
        text-color="white"
        label="Войти"
        type="submit"
      />
      <!-- <q-btn
        push
        size="sm"
        label="Стереть"
        type="reset"
        color="white"
        text-color="standard"
        class="q-ml-sm"
      /> -->
    </div>
    <div class="flex">
      <q-btn
        push
        size="md"
        type="reset"
        color="white"
        class="full-width"
        text-color="standard"
        :href='`https://esia.medsafe.tech/${hashLink}`'
        @click="setAppHash"
      >
        <b class="text-blue-grey-8">Войти через</b>
        <img alt="gu-logo" width="100px" class="q-ml-xs" src="@/assets/logo-gosuslugi-ru.png">
      </q-btn>
    </div>
  </q-form>

</div>
</template>

<script lang="ts">
import {
  defineComponent,
  reactive,
  ref,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '~store/auth/authModule';
import * as crypto from 'crypto-js';
import { setCookie } from '@/utils/cookies';

export default defineComponent({
  setup() {
    const data = reactive({
      login: '',
      password: '',
    });
    const authStore = useAuthStore();
    const isLoading = ref(false);
    const isPwd = ref(true);

    const { appHash } = storeToRefs(authStore);

    const onSubmit = () => {
      authStore.signIn(data.login, data.password);
    };
    const hashLink = computed(() => {
      const now = new Date();
      const date_str = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
      const hash = crypto.SHA1(`dev.ecohospital.ru${date_str}`);
      const digestHex = hash.toString(crypto.enc.Hex);
      return digestHex;
    });
    const setAppHash = () => {
      setCookie('dev-eco-hash', hashLink.value, { secure: true, expires: 1 });
    };
    const onReset = () => {
      data.login = '';
      data.password = '';
    };

    return {
      data,
      onSubmit,
      onReset,
      isPwd,
      hashLink,
      setAppHash,
    };
  },
});
</script>

<style>
.container {
  height: 60vh;
  margin: 10% 0;
}

.login-form-wrapper {
  border: 1px solid #eff5f9;
  border-radius: 1rem;
  background-color: #eff5f9;
  padding: 0.75rem;
}
</style>
